import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../components/DataNotFound';
import LoadingAnimation from '../../../components/LoadingAnimation';
import SearchFilters from '../../../components/elements/SearchFilter';
import { postAsync, putAsync } from '../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../components/helper/downloadCSVHelper';
import { getgwaManageList } from '../../../features/GWAManageListSlice';
import { PageHitCountApi } from '../../../shared/Helper';
import { printTable } from '../../../utils/tableExportUtils';
const GWAManageList = () => {
  const apiData = useSelector((state) => state.gwaManageList.list);
  const isActive = useSelector((state) => state.toggle.isActive);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [activestate, setActivestate] = useState(false);
  const [inActivestate, setInActivestate] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [next, setNext] = useState(1);
  const [order, setOrder] = useState(0);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const token = localStorage.getItem('token');
  const { pathname } = useLocation();

  const isLogin = () => {
    if (!token) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const pageOptions = {
    pageNo: 1,
    pageSize: 20,
  };

  const SearchFilter = {
    epUserID: 0,
    dateFrom: moment(dateFrom).format('DD/MM/YYYY'),
    dateTo: moment(dateTo).format('DD/MM/YYYY'),
    order,
  };
  const getData = async () => {
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync(
      `GWAService/GWAServiceApprovedFilterList/${pageOptions.pageNo}/${pageOptions.pageSize}`,
      SearchFilter,
      axiosConfig,
    )
      .then((response) => {
        setIsLoad(false);
        dispatch(getgwaManageList(response?.data));
        setPageCount(response?.page);
        setNext(pageOptions.pageNo);

        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  let axiosConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
  }, [order]);

  const bodyActive = {
    activeID: 1,
  };

  const handleActive = async (id) => {
    await putAsync('GWAService/GWAServiceActivation/', bodyActive, { id: id })
      .then((response) => {
        if (response?.statusCode === 200) {
          toast.success(`${t('Active Successfully')}`);
          getData();
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const bodyInActive = {
    activeID: 2,
  };
  const handleInActive = async (id) => {
    await putAsync('GWAService/GWAServiceActivation/', bodyInActive, { id: id })
      .then((response) => {
        if (response?.statusCode === 200) {
          toast.success(`${t('InActive Successfully')}`);
          getData();
        }
      })
      .catch((err) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    await postAsync('GWAService/GWAServiceApprovedFilterList/' + select + '/' + pageOptions.pageSize, SearchFilter)
      .then((response) => {
        dispatch(getgwaManageList(response.data));
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  // Export xlsl file
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      'S.No': ii + 1,
      'Full Name': item.fullName,
      Date: item.date,
      Time: item.timeNow,
      'Active ID': item?.activeID === 1 ? t('Active') : item.activeID === 2 ? t('Inactive') : t('Pending'),
    }));

    downloadCSV(filteredData, 'Good Will Ambassador Manage List');
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Manage list')}`; // Replace with your desired heading text
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('Full Name')}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Time`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Status`)}</th>

  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.fullName}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.date}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.timeNow}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.activeID === 1 ? t('Active') : data.activeID === 2 ? t('Inactive') : t('Pending')}</td>

  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);

  //   // Add CSS to hide everything except the table when printing
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);

  //   // Trigger the print dialog
  //   window.print();

  //   // Clean up by removing the table container and style from the DOM
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
  const handlePrint = (e) => {
    e.preventDefault();

    // Column configuration
    const columns = [
      {
        header: t('sNo'),
        accessor: (row, index) => index + 1,
      },
      {
        header: t('Full Name'),
        accessor: (row) => (isActive ? row?.fullName : row?.fullName),
      },
      {
        header: t('Date'),
        accessor: (row) => (isActive ? row?.date : row?.date),
      },
      {
        header: t('Time'),
        accessor: (row) => (isActive ? row?.timeNow || 'N/A' : row?.timeNow || 'N/A'),
      },
      {
        header: t('Status'),
        accessor: (row) => (row.activeID === 1 ? t('Active') : row.activeID === 2 ? t('Inactive') : t('Pending')),
      },
    ];

    // Call the reusable print function
    printTable({
      data: apiData || [],
      isRTL: isActive, // isActive true = Arabic = RTL
      t: t,
      title: `${t('Press Release List')} `,
      columns: columns,
      onBeforePrint: () => {
        console.log('Printing started...');
        // toast.info(t('Preparing print preview...'));
      },
      onAfterPrint: () => {
        console.log('Printing completed');
      },
      styles: {
        customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `,
      },
    });
  };
  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;

    return (
      <Table.Row key={index} items={apiData}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{data?.fullName}</Table.Cell>
        <Table.Cell>{data?.date}</Table.Cell>
        <Table.Cell>{data?.timeNow}</Table.Cell>
        <Table.Cell>
          {t(`${data?.activeID === 1 ? 'Active' : data.activeID === 2 ? 'Inactive' : 'Pending'}`)}
        </Table.Cell>
        <Table.Cell>
          <Link to={`/GWA_View/${data?.epUserID}`}>
            {/* <button className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-xl text-sm px-3 py-2.5 text-center">
              { t('View') }
            </button> */}
            <button className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center">
              <VisibilityOutlinedIcon />
            </button>
          </Link>
        </Table.Cell>
        <Table.Cell>
          <div className="ui radio checkbox flex-row items-center ">
            <input
              type="radio"
              checked={activestate === index || data.activeID === 1}
              onChange={() => {
                handleActive(data.gwaServiceID);
                setActivestate(index);
                setInActivestate(null); // Uncheck the InActive radio button for this record
              }}
              className="text-customgreen p-1 m-1 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm text-center"
              name={`activeInactive-${index}`}
            />
            <label>{t('Active')}</label>
          </div>
          <div className="ui radio checkbox flex flex-row items-center ">
            <input
              type="radio"
              checked={inActivestate === index || data.activeID === 2}
              onChange={() => {
                handleInActive(data.gwaServiceID);
                setInActivestate(index);
                setActivestate(null); // Uncheck the Active radio button for this record
              }}
              className="text-customgreen p-1 m-1 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm text-center"
              name={`activeInactive-${index}`}
            />
            <label>{t('Inactive')}</label>
          </div>
        </Table.Cell>
      </Table.Row>
    );
  });

  return (
    <>
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>
          <div className="container-fluid ">
            {/* <div className="row justify-center">
              <div className="col-lg-11 text-center">
                <h3 className="font-bold sm:text-2xl  text-xl text-customgreen">{t('Manage list')}</h3>
              </div>
            </div> */}
            <div className="row justify-center py-5 mt-3">
              <SearchFilters
                handleSearch={getData}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'Manage List'}
              />
              <div className="col-lg-11 text-center pt-9">
                <div className="flex flex-col">
                  <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                    {isLoad ? (
                      <LoadingAnimation />
                    ) : (
                      <Table className="text-sm tableData text-left rtl:text-right whitespace-nowrap">
                        <Table.Header className="font-bold text-white bg-customgreen uppercase  ">
                          <Table.Row>
                            <Table.HeaderCell className="text-white items-center align-middle">
                              {t('sNo')}
                            </Table.HeaderCell>
                            <Table.HeaderCell className="text-white items-center align-middle">
                              {t('Full Name')}
                            </Table.HeaderCell>
                            <Table.HeaderCell
                              className="text-white items-center align-middle"
                              onClick={() => {
                                setOrder(order == 0 ? 1 : 0);
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              {t('Date')}
                              {order ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />} {/* Add arrow indicator */}
                            </Table.HeaderCell>

                            <Table.HeaderCell className="text-white items-center align-middle">
                              {t('Time')}
                            </Table.HeaderCell>
                            <Table.HeaderCell className="text-white items-center align-middle">
                              {t('Active ID')}
                            </Table.HeaderCell>
                            <Table.HeaderCell className="text-white items-center align-middle">
                              {t('Details')}
                            </Table.HeaderCell>
                            <Table.HeaderCell className="text-white items-center align-middle">
                              {t('Actions')}
                            </Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>

                        <Table.Body>{displayRecords}</Table.Body>
                      </Table>
                    )}
                    {datanotfound && <DataNotFound />}
                  </div>
                </div>

                {pageCount > 0 && (
                  <div className="flex flex-row px-12 justify-between">
                    <Menu pagination>
                      <Menu.Item>
                        <ReactPaginate
                          previousLabel={t('Previous')}
                          nextLabel={t('Next')}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={'paginationButtons'}
                          previousLinkClassName={'previousButton'}
                          nextLinkClassName={'nextButton'}
                          disabledClassName={'paginationDisabled'}
                          activeClassName={'paginationActive'}
                        />
                      </Menu.Item>
                    </Menu>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default GWAManageList;
